import { EnvironmentProviders, InjectionToken, inject, makeEnvironmentProviders } from '@angular/core';
import { provideHttpClient } from '@angular/common/http';

import { environment } from '../../../../environments/environment';
import { ApiRepository } from './api-repository';
import { HttpRepository } from './http.repository';
import { MockRepository } from './mock.repository';

export const API_REPO = new InjectionToken<ApiRepository>('API_REPO');

export function provideApiRepository(): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideHttpClient(),
    {
      provide: API_REPO,
      useFactory: () => {
        return environment.useMock ? inject(MockRepository) : inject(HttpRepository);
      }
    }
  ]);
}
